<template lang="pug">
  container.my-120.md-my-90.px-15(width="md")
    .text-21.md-text-46.leading-xs.tracking-tight.text-center(v-html="row.text")
</template>

<script>
import Container from '@/components/Container'
export default {
  name: 'Quote',
  props: ['row'],
  components: { Container }
}
</script>

<style>
</style>
